export default async function guest({ next, store, to }) {
    if (to.name === 'genericLogin' && store.getters['auth/hasToken']) {
        return next({ name: 'home', replace: true });
    }

    const storageItem = window.localStorage.getItem("guest");
    if (storageItem === "isNotGuest" && !store.getters["auth/hasToken"]) {
        try {
            await store.dispatch("auth/ActionCheckToken");
            if (store.getters["auth/hasToken"]) {
                // next({ name: "dashboard" });
                next({ name: "home"});
            } else {
                store.dispatch("auth/ActionSetGuest", { value: "isGuest" });
                next({ name: "home"});
            }
        } catch (error) {
            store.dispatch("auth/ActionSetGuest", { value: "isGuest" });
            next({ name: "home"});
        }
    } else {
        next();
    }
}
  